module.exports = __webpack_public_path__ + "img/un.fcf6200e.svg";